import React from 'react';

import DateControl from 'app/components/Controls/DateControl';
import { TravelDateRangeControlProps } from './TravelDateRangeControl.interfaces';
import { useTravelDateRangeControl } from './useTravelDateRangeControl';

export default function TravelDateRangeControl(
  props: TravelDateRangeControlProps
) {
  const {
    isRangeField,
    isRangeDialogOpen,
    handleRegisterCommit,
    handleRequestOpen,
  } = useTravelDateRangeControl(props);

  if (!isRangeField) {
    return <DateControl {...props} />;
  }

  return (
    <DateControl
      {...props}
      renderDialog={false}
      isExternalDialogOpen={isRangeDialogOpen}
      onRequestOpen={handleRequestOpen}
      onRegisterCommit={handleRegisterCommit}
    />
  );
}
